type CameraIconSvgProps = {
  className?: string;
  color?: string;
};

export const CameraIconSvg = ({
  className,
  color = "#A8B4BD",
}: CameraIconSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    className={className}
  >
    <g clipPath="url(#clip0_7071_911)">
      <path
        d="M13.9571 7.31319V4.90043C13.9571 4.38061 13.7506 3.88207 13.3831 3.5145C13.0155 3.14693 12.517 2.94043 11.9971 2.94043H2.80082C2.281 2.94043 1.78246 3.14693 1.41489 3.5145C1.04732 3.88207 0.84082 4.38061 0.84082 4.90043V14.7004C0.84082 15.2203 1.04732 15.7188 1.41489 16.0864C1.78246 16.4539 2.281 16.6604 2.80082 16.6604H11.9971C12.517 16.6604 13.0155 16.4539 13.3831 16.0864C13.7506 15.7188 13.9571 15.2203 13.9571 14.7004V12.2877L17.0402 13.9321C17.1895 14.0116 17.3568 14.0511 17.5259 14.0468C17.6949 14.0425 17.86 13.9945 18.005 13.9074C18.15 13.8204 18.2701 13.6974 18.3535 13.5502C18.4368 13.4031 18.4807 13.2369 18.4808 13.0677V6.53311C18.4807 6.36399 18.4368 6.19777 18.3535 6.05063C18.2701 5.90349 18.15 5.78043 18.005 5.69342C17.86 5.60641 17.6949 5.55841 17.5259 5.55408C17.3568 5.54976 17.1895 5.58926 17.0402 5.66875L13.9571 7.31319Z"
        stroke={color}
        strokeWidth="1.995"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7071_911">
        <rect
          width="19.6"
          height="19.6"
          fill="white"
          transform="translate(-0.139648)"
        />
      </clipPath>
    </defs>
  </svg>
);
